import React from 'react';
import Select from 'blocks/Select';
import {inject, observer } from 'mobx-react';
import Input from 'blocks/Input';
import HttpClient from 'services/HttpClient';
import validate from 'validate.js';
import Checkbox from 'blocks/filters/Checkbox';
import _ from 'lodash';
const UPDATE_USER = '/api/v1/users/update_profile';

const USER_CONSTRAINS = {
  first_name: {
    length: {
      minimum: 1,
      maximum: 20,
      tooShort: 'is required',
      tooLong: 'maximum 20 symbols'
    }
  },
  last_name: {
    length: {
      minimum: 1,
      maximum: 20,
      tooShort: 'is required',
      tooLong: 'maximum 20 symbols'
    }
  }
};

const options = [
  { value: 'Counsellor', title: 'Counsellor' },
  { value: 'Psychotherapist', title: 'Psychotherapist' },
  { value: 'Psychologist', title: 'Psychologist' },
  { value: 'Psychiatrist', title: 'Psychiatrist' },
  { value: 'Supervisor', title: 'Supervisor' },
  { value: 'Student', title: 'Student' },
  { value: 'Healthcare Professional', title: 'Healthcare Professional' },
  { value: 'Life Coach', title: 'Life Coach' },
  { value: 'Other Professional', title: 'Other Professional' },
  { value: 'General Public', title: 'General Public' }
];




@inject('user')
@inject('alert')
@observer
export default class EditProfile extends React.Component {


  componentWillMount = () => {
    this.setState({
      errors: {},
      avatar_url: this.props.user.getUser().avatar_url,
      user: {
        proffession_description: this.props.user.getUser().proffession_description,
        first_name: this.props.user.getUser().first_name,
        last_name: this.props.user.getUser().last_name,
        email_notification: this.props.user.getUser().email_notification
      }
    });
  };

  handleChangeEmailNotificaton = () => {
    let newState = _.assign({}, this.state.user, {email_notification: !this.state.user.email_notification});
    this.setState({user: newState});
  };

  submitForm = e => {
    e.preventDefault();
    let errors = validate(this.state.user, USER_CONSTRAINS);
    if(errors !== undefined){
      this.setState({errors: errors});
      return;
    }

    new HttpClient().put(UPDATE_USER, {user: this.state.user })
      .then(response => {
        console.log(response)
        this.props.alert.success('Your profile has been saved');
        this.props.user.setUser(response.body.data.user)});

  };

  handleChange = data => {
    let newState = _.assign({}, this.state.user, data);
    this.setState({user: newState});
  };

  logOut = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("purchaseMessageSeen");
    this.props.history.push("/");
    this.props.user.setUser(null);
  };

  render(){
    return (
    <form onSubmit={this.submitForm}
                  formNoValidate>
      {this.props.user.user.role !== 'iacp' && <div className="row">
        <div className="col">
          <Select
            elements={options}
            placeholder="Select Member Type"
            label="Select Member Type"
            name="proffession_description"
            value={this.state.user.proffession_description}
            handleChange={this.handleChange}
          />
        </div>
      </div>}
      <div className="row">
        <div className="col">
          <Input name="first_name"
                 type="text"
                 value={this.state.user.first_name}
                 handleChange={this.handleChange}
                 placeholder="First name"
                 error={this.state.errors.first_name}
                 disabled={(this.props.user.user.role === 'iacp' ? true : null)}       
          />
        </div>
      </div>
      <div className="row">
      <div className="col">
        <Input name="last_name"
               type="text"
               value={this.state.user.last_name}
               handleChange={this.handleChange}
               placeholder="Last name"
               error={this.state.errors.last_name}
               disabled={(this.props.user.user.role === 'iacp' ? true : null)}
        />
      </div>
    </div>

      <div className="row">
        <div className="col">
          <Input name="email"
                 disabled={true}
                 type="text"
                 value={this.props.user.getUser().email}
                 handleChange={() => {} }
                 placeholder="Email"
                 />
        </div>
      </div>
      <div className="row">
        <div className="col email-notification-checkbox" style={{paddingLeft: 0}}>
          <Checkbox value={this.state.user.email_notification}
                    id="email_notification"
                    fullWidth={true}
                    label='Email Notifications'
                    checked={this.state.user.email_notification}
                    handleChange={this.handleChangeEmailNotificaton}/>
        </div>
      </div>
      <div className="btn-holder">
        <button type="submit" className="btn blue empty bordered">save</button>
        <button className="btn blue empty bordered" style={{marginLeft: 25}} onClick={e => this.logOut(e)}>log out</button>
      </div>
    </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/my_profile/EditProfile.jsx